import { render, staticRenderFns } from "./TrustPilotReview.vue?vue&type=template&id=5895d635&"
import script from "./TrustPilotReview.vue?vue&type=script&lang=ts&"
export * from "./TrustPilotReview.vue?vue&type=script&lang=ts&"
import style0 from "./TrustPilotReview.vue?vue&type=style&index=0&id=5895d635&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QAvatar,QImg,QBtn,QSeparator});
